// export const CONTEXT = './api';
export const CONTEXT = process.env.VUE_APP_BASE_API;
export const WADO_CONTEXT = process.env.VUE_APP_WADO_API;

export const PROSISSION_CONTEXT = process.env.VUE_APP_PROMISSION_API + "/api";

export const LOGIN = CONTEXT + '/login';
export const LOGOUT = CONTEXT + '/logout';
export const CHANGE_PWD = CONTEXT + '/changePwd';

//系统
export const SYS_MODULE_LIST = PROSISSION_CONTEXT + '/app/QueryModule'
export const SYS_APP_QUERY = PROSISSION_CONTEXT + '/app/Query';
export const SYS_MENU_GET = PROSISSION_CONTEXT + '/sys/menu/get';
export const SYS_MENU_UPDATE = PROSISSION_CONTEXT + '/app/UpdateModule';
export const SYS_MENU_DELETE = PROSISSION_CONTEXT + '/sys/menu/delete';
export const SYS_MENU_ADD = PROSISSION_CONTEXT + '/app/AddModule';
export const SYS_MENU_PAGE = PROSISSION_CONTEXT + '/sys/menu/page';
export const SYS_MENU_LIST = PROSISSION_CONTEXT + '/app/QueryModule';
export const SYS_MENU_LIST2 = PROSISSION_CONTEXT + '/sys/menu/list2';

export const SYS_ROLE_GET = PROSISSION_CONTEXT + '/sys/role/get';
export const SYS_ROLE_UPDATE = PROSISSION_CONTEXT + '/sys/role/update';
export const SYS_ROLE_DELETE = PROSISSION_CONTEXT + '/sys/role/delete';
export const SYS_ROLE_ADD = PROSISSION_CONTEXT + '/sys/role/add';
export const SYS_ROLE_PAGE = PROSISSION_CONTEXT + '/sys/role/page';
export const SYS_ROLE_LIST = PROSISSION_CONTEXT + '/sys/role/list';
export const SYS_ROLE_LIST2 = PROSISSION_CONTEXT + '/sys/role/list2';
export const SYS_ROLE_RESOURCE = PROSISSION_CONTEXT + '/app/RoleMappingModuleIds';
export const SYS_SET_ROLE_RESOURCE = PROSISSION_CONTEXT + '/app/SetRoleMappingModule';

export const SYS_RESOURCE_GET = PROSISSION_CONTEXT + '/sys/resource/get';
export const SYS_RESOURCE_UPDATE = PROSISSION_CONTEXT + '/sys/resource/update';
export const SYS_RESOURCE_DELETE = PROSISSION_CONTEXT + '/sys/resource/delete';
export const SYS_RESOURCE_ADD = PROSISSION_CONTEXT + '/sys/resource/add';
export const SYS_RESOURCE_PAGE = PROSISSION_CONTEXT + '/sys/resource/page';
export const SYS_RESOURCE_LIST = PROSISSION_CONTEXT + '/sys/resource/list';
export const SYS_RESOURCE_LIST2 = PROSISSION_CONTEXT + '/sys/resource/list2';

export const SYS_USER_GET = PROSISSION_CONTEXT + '/sys/user/get';
export const SYS_USER_ADD = PROSISSION_CONTEXT + '/sys/user/add';
export const SYS_USER_UPDATE = PROSISSION_CONTEXT + '/sys/user/update';
export const SYS_USER_DELETE = PROSISSION_CONTEXT + '/sys/user/delete';
export const SYS_USER_PAGE = PROSISSION_CONTEXT + '/Users';
export const SYS_USER_ROLE = PROSISSION_CONTEXT + '/sys/user/roleIds';
export const SYS_USER_SETLOCKOUT = PROSISSION_CONTEXT + '/Users/ChangeUserStatus';
export const SYS_SET_USER_ROLE = PROSISSION_CONTEXT + '/sys/user/setRoles';


export const MSG_TOP_TEN = CONTEXT + '/messageList';
export const TEST_DATA = CONTEXT + '/static/data/data.json';

//start
export const HOMEPAGEDATA_MAPDATA = CONTEXT + "/api/Home/MapData"; //地图数据 
export const HOMEPAGEDATA_HOSPITALDATA = CONTEXT + "/api/Home/HospitalData"; //医院数据 
export const HOMEPAGEDATA_PROVINCEDATA = CONTEXT + "/api/Home/ProvinceData"; //省份数据
export const HOMEPAGEDATA_PLATFORMDATA = CONTEXT + "/api/Home/PlatformData"; //平台数据
export const HOMEPAGEDATA_UploadData = CONTEXT + "/api/Home/UploadData"; //上传数据
export const HOMEPAGEDATA_UploadProportionData = CONTEXT + "/api/Home/StudyProportion"; //上传占比数据

export const HOMEPAGEDATA_MontiorData = CONTEXT + "/api/Home/MonitorData"; //监控数据


export const DICTIONARY_LIST = CONTEXT + "/api/Dictionary/List"; //获取字典列表
export const DICTIONARY_TYPETREE = CONTEXT + "/api/Dictionary/TypeTree"; //获取字典树
export const DICTIONARY_ADD = CONTEXT + "/api/Dictionary/Add"; //新增字典值
export const DICTIONARY_DELETE = CONTEXT + "/api/Dictionary/delete"; //删除字典值
export const DICTIONARY_UPDATE = CONTEXT + "/api/Dictionary/Update"; //修改字典值
export const DICTIONARY_SELECTDICT = CONTEXT + "/api/Dictionary/SelectDict"; //获取字典值集合

//客户端
export const Client_LIST = CONTEXT + "/api/Client/List"; //获取客户端列表
export const Client_ObjectLIST = CONTEXT + "/api/Client/ClientList"; //获取客户下拉列表
export const Client_ADD = CONTEXT + "/api/Client/Add"; //添加客户端
export const Client_UPDATE = CONTEXT + "/api/Client/Update"; //修改客户端
export const Client_SETSTATUS = CONTEXT + "/api/Client/UpdateStatus"; //启用禁用客户端
export const Client_SetSecretKey = CONTEXT + "/api/Client/SetSecretKey"; //设置秘钥
export const Client_SetPurview = CONTEXT + "/api/Client/SetPurview"; //设置权限

//存储
export const Storage_LIST = CONTEXT + "/api/Storage/List"; //获取存储列表
export const Storage_ADD = CONTEXT + "/api/Storage/Add"; //添加存储
export const Storage_UPDATE = CONTEXT + "/api/Storage/Update"; //修改存储
export const Storage_DELETE = CONTEXT + "/api/Storage/Delete"; //删除存储

//存储级别
export const Level_LIST = CONTEXT + "/api/Level/List"; //获取级别列表
export const Level_StorageList = CONTEXT + "/api/Level/StorageList"; //获取存储下拉选项
export const Level_ADD = CONTEXT + "/api/Level/Add"; //添加级别
export const Level_UPDATE = CONTEXT + "/api/Level/Update"; //修改级别
export const Level_DELETE = CONTEXT + "/api/Level/SetStatus"; //启|停用级别
export const Level_TEMP = CONTEXT + "/api/Level/SetTempStorage"; //设置临时存储
export const Level_MaxOrder = CONTEXT + "/api/Level/GetMaxStorageIndex"; //获取最大临时存储

//临时存储
export const StorageTemp_Get = CONTEXT + "/api/StorageTemp/List"; //获取存储列表
export const StorageTemp_Save = CONTEXT + "/api/StorageTemp/Save"; //提交临时存储

//医院
export const HOSPITAL_LIST = CONTEXT + "/api/Hospital/List"; //获取医院列表
export const HOSPITAL_ADD = CONTEXT + "/api/Hospital/Add"; //新增医院
export const HOSPITAL_UPDATE = CONTEXT + "/api/Hospital/Update"; //更新医院信息
export const HOSPITAL_SETSTATUS = CONTEXT + "/api/Hospital/SetStatus"; //删除
export const HOSPITAL_STORAGEINFO = CONTEXT + "/api/Hospital/StorageInfo"; //获取存储套餐信息
export const HOSPITAL_SAVESTORAGE = CONTEXT + "/api/Hospital/SaveStorage"; //保存影像存储设置
export const HOSPITAL_DELETECHARGE = CONTEXT + "/api/Hospital/DeleteCharge"; //删除存储套餐
export const HOSPITAL_AIINFO = CONTEXT + "/api/Hospital/AIInfo"; //获取AI项目列表
export const HOSPITAL_SAVEAI = CONTEXT + "/api/Hospital/SaveAI"; //保存AI设置
export const HOSPITAL_GetInquiryInfo = CONTEXT + "/api/Hospital/GetInquiryInfo"; //获取在线问诊设置
export const HOSPITAL_SaveInquiry = CONTEXT + "/api/Hospital/SaveInquiry"; //保存在线问诊设置
export const HOSPITAL_SelectHospitals = CONTEXT + "/api/Hospital/SelectHospitals"; //获取医院(含科室)列表
export const HOSPITAL_HospitalUser = CONTEXT + "/api/HospitalUser/List"; //获取医院账号列表
export const HOSPITAL_SelectNames = CONTEXT + "/api/HospitalUser/SelectNames"; //获取医院账号类型列表
export const HOSPITAL_Trees = CONTEXT + "/api/HospitalUser/Tree"; //获取医疗列表树
export const HOSPITALUser_Add = CONTEXT + "/api/HospitalUser/Add"; //添加账户数据
export const HOSPITAL_HospitalList = CONTEXT + "/api/HospitalUser/HospitalList"; //获取医院全部列表
export const HOSPITAL_HospitalUserUpdate = CONTEXT + "/api/HospitalUser/update"; //修改医院账号信息
export const HOSPITAL_HospitalUserUpdateStatus = CONTEXT + "/api/HospitalUser/UpdateStatus"; //修改医院账号状态
export const HOSPITAL_HospitalUserResetPassword = CONTEXT + "/api/HospitalUser/ResetPassword"; //重置医院账号密码
export const HospitalUser_SetDataPermission = CONTEXT + "/api/HospitalUser/SetDataPermission"; //设置用户数据权限

export const HOSPITAL_SavePicsSetting = CONTEXT + "/api/CloudFilmSetting/SavepicsSetting"; //保存科室配置
export const HOSPITAL_GETPicsSETTING = CONTEXT + "/api/CloudFilmSetting/GetPicsSetting"; //获取临床复选框状态

export const HOSPITAL_SELECTDATA = CONTEXT + "/api/CloudFilmSetting/SelectData"; //获取配置数据字典
export const HOSPITAL_GetSAVERULE = CONTEXT + "/api/CloudFilmSetting/GetSaveRule"; //获取医院验证模式
export const HOSPITAL_GetAUTHENTYPE = CONTEXT + "/api/CloudFilmSetting/GetAuthenType"; //获取医院登录方式

export const HOSPITAL_UploadImage = CONTEXT + "/api/CloudFilmSetting/UploadImage"; //上传图片
export const HOSPITAL_GetImage = CONTEXT + "/api/CloudFilmSetting/GetImage"; //上传图片
export const HOSPITAL_GETSETTING = CONTEXT + "/api/CloudFilmSetting/GetSetting"; //获取医院复选框状态
export const HOSPITAL_UpdateCloudBase = CONTEXT + "/api/CloudFilmSetting/SaveBase"; //获取医院复选框状态
export const HOSPITAL_SaveHomepageSetting = CONTEXT + "/api/CloudFilmSetting/SaveHomepageSetting"; //保存首页配置

export const HOSPITAL_ClientSelect = CONTEXT + "/api/client/GetHospitalClient"; //获取上传客户端集合
export const HOSPITAL_ClientInfo = CONTEXT + "/api/HospitalClient/GetClient"; //获取图像网关信息
export const HOSPITAL_ClientSave = CONTEXT + "/api/HospitalClient/SaveClient"; //保存图像网关设置

export const HOSPITAL_GatewayDetail = CONTEXT + "/api/HospitalClientSyncData/PageList"; //获取网关任务信息

//系统设置
export const HOSPITAL_GetReportstatisticrule = CONTEXT + "/api/HospitalSystem/Get"; //获取报告设置规则
export const HOSPITAL_UpdateReportstatisticrule = CONTEXT + "/api/HospitalSystem/Update"; //更新报告设置规则
export const HOSPITAL_GetStudyuploadnotice = CONTEXT + "/api/HospitalSystem/GetStudyuploadnotice"; //获取云存储通知设置规则
export const HOSPITAL_UpdateStudyuploadnotice = CONTEXT + "/api/HospitalSystem/UpdateStudyuploadnotice"; //更新云存储通知设置规则
export const HOSPITAL_SaveDeleteImageSetting = CONTEXT + "/api/HospitalSystem/SaveDeleteImageSetting"; //更新屏蔽影像删除文件
export const HOSPITAL_GetDeleteImageSetting = CONTEXT + "/api/HospitalSystem/GetDeleteImageSetting"; //获取屏蔽删除影像设置
export const HOSPITAL_SaveFilterThinSetting = CONTEXT + "/api/HospitalSystem/SaveFilterThinSetting"; //更新过滤薄层影像文件
export const HOSPITAL_GetFilterThinSetting = CONTEXT + "/api/HospitalSystem/GetFilterThinSetting"; //获取过滤薄层影像设置

//审计
export const AUDIT_ViewerLIST = CONTEXT + "/api/Viewer/List"; //调阅记录列表
export const AUDIT_ArchiveLIST = CONTEXT + "/api/ArchiveRecord/List"; //归档记录列表
export const AUDIT_UploadLIST = CONTEXT + "/api/UploadRecord/List"; //上传记录列表
export const AUDIT_RestoreLIST = CONTEXT + "/api/RestoreRecord/List"; //存储还原记录列表
export const AUDIT_ClientLogLIST = CONTEXT + "/api/ClientLog/List"; //客户端日志列表
export const OperationLog_List = CONTEXT + '/api/OperationLog/List'; //操作日志列表
export const AUDIT_ReportShareLIST = CONTEXT + "/api/ReportShare/List"; //分享记录列表
export const AUDIT_ReportShareRevoke = CONTEXT + "/api/ReportShare/Revoke"; //分享撤销
export const AUDIT_ReportShareViewList = CONTEXT + "/api/ReportShare/ViewList"; //分享查看列表

//图像管理
export const Report_List = CONTEXT + '/api/Study/CloudFilmList'; //報告列表
export const Study_List = CONTEXT + '/api/Study/List'; //检查列表
export const Study_StorageList = CONTEXT + '/api/Study/StorageList'; //存储记录
export const Study_Viewer = WADO_CONTEXT + "/api/Wado"; //影像阅片
export const Study_Report = WADO_CONTEXT + "/api/StudyReport/GetReport"; //结构化数据
export const Study_ElectReport = WADO_CONTEXT + "/api/StudyReport/GetElectReport"; //电子报告
export const Study_ElectFilm = WADO_CONTEXT + "/api/StudyReport/GetElectFilm"; //电子胶片
export const Study_Delete = CONTEXT + '/api/Study/Delete'; //检查删除

//云胶片
export const CLOUDFILM_CLOUDFILMLIST = CONTEXT + "/api/CloudFilm/CloudFilmList"; //云胶片明细列表
export const CLOUDFILM_GETSCANTRACE = CONTEXT + "/api/CloudFilm/GetScanTrace"; //扫码痕迹
export const CLOUDFILM_GETREPORTINFO = CONTEXT + "/api/CloudFilm/GetReportInfo"; //报告详情
//分享记录
export const CLOUDFILM_SHARELIST = CONTEXT + "/api/CloudFilm/ShareList"; //分享记录列表
export const CLOUDFILM_ShareView = CONTEXT + "/api/CloudFilm/ShareView"; //分享查看记录
export const CLOUDFILM_ShareStudy = CONTEXT + "/api/CloudFilm/ShareStudy"; //分享报告记录
export const CLOUDFILM_RECALL = CONTEXT + "/api/CloudFilm/SetStatus"; //撤销分享
//下载记录
export const CLOUDFILM_FilmDownList = CONTEXT + "/api/FilmDownload/FilmDownList"; //下载操作记录列表
export const CLOUDFILM_Reload = CONTEXT + "/api/FilmDownload/Reload"; //撤销邮件发送
export const CLOUDFILM_SendEmailList = CONTEXT + "/api/FilmDownload/SendEmailList"; //发送邮件记录列表
export const CLOUDFILM_DownDetailList = CONTEXT + "/api/FilmDownload/DownDetailList"; //下载详情
export const CLOUDFILM_CancelSenEmail = CONTEXT + "/api/FilmDownload/CancelSenEmail"; //撤销邮件发送

//临床下载记录
export const CLINIC_FilmDownList = CONTEXT + "/api/ClinicFilmDownload/FilmDownList"; //下载操作记录列表
export const CLINIC_DownDetailList = CONTEXT + "/api/ClinicFilmDownload/DownDetailList"; //下载详情
export const CLINIC_Reload = CONTEXT + "/api/CLinicFilmDownload/Reload"; //重新发送

//统计
export const Statistics_Readstatistic = CONTEXT + '/api/ReadStatistic/ReadDatas'; //调阅统计
export const Statistics_Filmstatistic = CONTEXT + '/api/ReadStatistic/ReadFilmDatas'; //云胶片调阅统计
export const Statistics_Workloadstatistic = CONTEXT + '/api/WorkloadStatistic/GetWorkloads'; //医生工作量
export const Statistics_WorkloadstatisticExcel = CONTEXT + '/api/WorkloadStatistic/GetWorkloadsExcel'; //医生工作量导出excel
export const Statistics_Archivestatistic = CONTEXT + '/api/Archive/List'; //归档统计

export const HOSPITAL_Hospitalrole = CONTEXT + "/api/HospitalRole/List"; //获取医院账号角色列表
export const HOSPITAL_HospitalroleAdd = CONTEXT + "/api/HospitalRole/Add"; //添加医院账号角色列表
export const HOSPITAL_HospitalroleUpdateStatus = CONTEXT + "/api/HospitalRole/UpdateStatus"; //添加医院账号角色状态
export const HOSPITAL_HospitalroleUpdate = CONTEXT + "/api/HospitalRole/Update"; //添加医院账号角色状态
export const HOSPITAL_PermissionMenu = CONTEXT + "/api/HospitalRole/PermissionMenu"; //角色权限菜单
export const HOSPITAL_RolePermission = CONTEXT + "/api/HospitalRole/RolePermission"; //获取角色权限菜单
export const HOSPITAL_SetRolePermission = CONTEXT + "/api/HospitalRole/AddRolePermission"; //设置权限菜单
export const HOSPITAL_HospitalRoleList = CONTEXT + "/api/HospitalRole/HosptailRole"; //医院角色
export const HOSPITAL_HospitalUserRoleList = CONTEXT + "/api/HospitalRole/UserRole"; //用户角色
export const HOSPITAL_AddHospitalUserRoleList = CONTEXT + "/api/HospitalRole/AddUserRole"; //添加用户角色
export const HOSPITAL_AddHospitalCopyRoleList = CONTEXT + "/api/HospitalRole/CopyRole"; //复制角色
export const HOSPITAL_AddHospitalUserList = CONTEXT + "/api/HospitalRole/UserList"; //角色用户列表
export const HOSPITAL_ReportTemplateList = CONTEXT + "/api/ReportTemplate/List"; //设备类型维护列表
export const HOSPITAL_DeviceInfoadd = CONTEXT + "/api/ReportTemplate/Add"; //添加设备类型维护
export const HOSPITAL_DeviceInfoUpdate = CONTEXT + "/api/ReportTemplate/Update"; //编辑设备类型维护
export const HOSPITAL_DeviceInfoUpdateStatus = CONTEXT + "/api/ReportTemplate/UpdateStatus"; //启禁用设备类型维护


//网关配置
export const GateWay_OfficeList = CONTEXT + "/api/GateWay/OfficeList"; //获取科室列表
export const GateWay_Office= CONTEXT + "/api/GateWay/OfficeCode"; //科室配置信息
export const GateWay_HspsList= CONTEXT + "/api/GateWay/HspsList"; //获取全院配置
export const GateWay_PublicConf= CONTEXT + "/api/GateWay/PublicConf"; //获取公共配置
export const GateWay_ImsConf= CONTEXT + "/api/GateWay/ImsConf"; //获取IMS配置
export const GateWay_FilmDownLoad= CONTEXT + "/api/GateWay/FilmDownLoad"; //获取科室电子胶片设置
export const GateWay_ReportDownLoad= CONTEXT + "/api/GateWay/ReportDownLoad"; //获取科室电子报告设置





// WEBPACK FOOTER //
// ./src/api.js